import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormType } from '../../backend/openapi/api-types';
import { useSearchParam } from '../../../core/routing/hooks/use-search-param';
import { SearchParam } from '../../../core/routing/param';
import { AuthenticatedForm } from './authenticated-form';

export const ServiceRequest: React.FC = () => {
  const { t } = useTranslation();
  const params = useSearchParam([SearchParam.articleId]);

  return (
    <AuthenticatedForm
      documentTitle={t('form.serviceRequest.documentTitle')}
      formType={FormType.serviceRequest}
      queryParam={params}
    />
  );
};
